/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */
import { __spreadArray } from "tslib";
import { Segmentation } from '../../../../mol-data/int';
import { CifWriter } from '../../../../mol-io/writer/cif';
import { StructureElement, Unit } from '../../structure';
var CifField = CifWriter.Field;
import { residueIdFields } from './atom_site';
import { ModelSecondaryStructure } from '../../../../mol-model-formats/structure/property/secondary-structure';
export var _struct_conf = {
    name: 'struct_conf',
    instance: function (ctx) {
        var elements = findElements(ctx, 'helix');
        return {
            fields: struct_conf_fields(),
            source: [{ data: elements, rowCount: elements.length }]
        };
    }
};
export var _struct_sheet_range = {
    name: 'struct_sheet_range',
    instance: function (ctx) {
        var elements = findElements(ctx, 'sheet').sort(compare_ssr);
        return {
            fields: struct_sheet_range_fields(),
            source: [{ data: elements, rowCount: elements.length }]
        };
    }
};
function compare_ssr(x, y) {
    var a = x.element, b = y.element;
    return a.sheet_id < b.sheet_id ? -1 : a.sheet_id === b.sheet_id ? x.start.element - y.start.element : 1;
}
;
var struct_conf_fields = function () { return __spreadArray(__spreadArray(__spreadArray([
    CifField.str('conf_type_id', function (i, data) { return data[i].element.type_id; }),
    CifField.str('id', function (i, data, idx) { return "".concat(data[i].element.type_id).concat(idx + 1); })
], residueIdFields(function (i, e) { return e[i].start; }, { prefix: 'beg' }), true), residueIdFields(function (i, e) { return e[i].end; }, { prefix: 'end' }), true), [
    CifField.str('pdbx_PDB_helix_class', function (i, data) { return data[i].element.helix_class; }),
    CifField.str('details', function (i, data) { return data[i].element.details || ''; }, {
        valueKind: function (i, d) { return !!d[i].element.details ? 0 /* Column.ValueKinds.Present */ : 2 /* Column.ValueKinds.Unknown */; }
    }),
    CifField.int('pdbx_PDB_helix_length', function (i, data) { return data[i].length; })
], false); };
var struct_sheet_range_fields = function () { return __spreadArray(__spreadArray(__spreadArray([
    CifField.str('sheet_id', function (i, data) { return data[i].element.sheet_id; }),
    CifField.index('id')
], residueIdFields(function (i, e) { return e[i].start; }, { prefix: 'beg' }), true), residueIdFields(function (i, e) { return e[i].end; }, { prefix: 'end' }), true), [
    CifField.str('symmetry', function (i, data) { return ''; }, { valueKind: function (i, d) { return 2 /* Column.ValueKinds.Unknown */; } })
], false); };
function findElements(ctx, kind) {
    // TODO: encode secondary structure for different models?
    var secondaryStructure = ModelSecondaryStructure.Provider.get(ctx.firstModel);
    if (!secondaryStructure)
        return [];
    var key = secondaryStructure.key, elements = secondaryStructure.elements;
    var ssElements = [];
    var structure = ctx.structures[0];
    for (var _i = 0, _a = structure.unitSymmetryGroups; _i < _a.length; _i++) {
        var units = _a[_i].units;
        var u = units[0];
        if (!Unit.isAtomic(u))
            continue;
        var segs = u.model.atomicHierarchy.residueAtomSegments;
        var residues = Segmentation.transientSegments(segs, u.elements);
        var current = void 0, move = true;
        while (residues.hasNext) {
            if (move)
                current = residues.move();
            var start = current.index;
            var startIdx = key[start];
            var element = elements[startIdx];
            if (element.kind !== kind) {
                move = true;
                continue;
            }
            var prev = start;
            while (residues.hasNext) {
                prev = current.index;
                current = residues.move();
                if (startIdx !== key[current.index]) {
                    move = false;
                    ssElements[ssElements.length] = {
                        start: StructureElement.Location.create(structure, u, segs.offsets[start]),
                        end: StructureElement.Location.create(structure, u, segs.offsets[prev]),
                        length: prev - start + 1,
                        element: element
                    };
                    break;
                }
            }
        }
    }
    return ssElements;
}
